import { JsonPipe, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { TimePickerModule } from '@progress/kendo-angular-dateinputs';
import { NumericTextBoxModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { QPointFormGroupComponent, QPointFormLabelComponent, QPointReactiveFormInputGroupComponent } from '@qpoint/forms';
import { QPointContentContainerComponent, QPointToolbarComponent } from '@qpoint/layout';

import { QPointButtonComponent } from '../../../../projects/qpoint-button/src/lib/button/button.component';
import {
  QPointPasswordInputComponent,
} from '../../../../projects/qpoint-forms/src/lib/password-input/password-input.component';
import {
  QPointTimepickerAutocompleteDirective,
} from '../../../../projects/qpoint-forms/src/lib/time-picker/time-picker-autocomplete';
import {
  QPointTimePickerOverrideDirective,
} from '../../../../projects/qpoint-forms/src/lib/time-picker/time-picker-override.directive';
import { QPointTimePickerUnitDirective } from '../../../../projects/qpoint-forms/src/lib/time-picker/time-picker-unit';
import { ControlGalleryAsyncDropDownComponent } from './async-drop-down/async-drop-down.component';
import { ColorPickerDemoComponent } from './color-picker-demo/color-picker-demo.component';
import { DateTimePickerDemoComponent } from './datetime-picker-demo/datetime-picker-demo.component';
import { DeliveryNoteTransferDemoComponent } from './delivery-note-transfer-demo/delivery-note-transfer-demo.component';
import { ControlGalleryDropDownListComponent } from './drop-down-list/drop-down-list.component';
import {
  MultiViewDateRangePickerDemoComponent,
} from './multi-view-date-range-picker-demo/multi-view-date-range-picker-demo.component';
import { ControlGalleryMultipleEmailsInputComponent } from './multiple-emails-input/multiple-emails-input.component';
import { NullValueDirectiveComponent } from './null-value-directive/null-value-directive.component';
import { ControlGallerySuggestListComponent } from './suggest-list/suggest-list.component';


@Component({
    selector: 'app-control-gallery-form',
    templateUrl: './form.component.html',
    imports: [
        QPointToolbarComponent,
        QPointContentContainerComponent,
        ColorPickerDemoComponent,
        MultiViewDateRangePickerDemoComponent,
        DateTimePickerDemoComponent,
        TimePickerModule,
        QPointTimepickerAutocompleteDirective,
        QPointTimePickerUnitDirective,
        QPointTimePickerOverrideDirective,
        FormsModule,
        ReactiveFormsModule,
        QPointFormGroupComponent,
        QPointFormLabelComponent,
        NgIf,
        QPointReactiveFormInputGroupComponent,
        QPointButtonComponent,
        ControlGalleryDropDownListComponent,
        ControlGalleryAsyncDropDownComponent,
        ControlGallerySuggestListComponent,
        ControlGalleryMultipleEmailsInputComponent,
        NullValueDirectiveComponent,
        NumericTextBoxModule,
        DeliveryNoteTransferDemoComponent,
        JsonPipe,
        QPointPasswordInputComponent,
        TextBoxModule
    ]
})
export class ControlGalleryFormComponent implements OnInit {
  public form: UntypedFormGroup;
  public validatorsUpdated = false;
  public messages = {
    email: 'E-Mail Adresse fehlerhaft',
    required: 'Feld ist ein Pflichfeld',
  };
  public submitted = false;
  dateMin = new Date('2023-10-09T22:01:00.000Z')
  timePickerFc = new FormControl();

  public kendoTextboxValue = "Eine Textbox";
  public kendoNumericTextboxValue = 12345;

  get email() {
    return this.form.get('email') as UntypedFormControl;
  }

  constructor(private formBuilder: UntypedFormBuilder) {
    this.timePickerFc.valueChanges.subscribe(
      (value) => {
        console.log("timepickerfc: ", value);
      }
    )
  }

  public get number() {
    return this.form.get('number');
  }

  public get password() {
    return this.form.get('password');
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(5)]],
      description: ['', [Validators.required, Validators.minLength(10)]],
      number: [null, Validators.required],
      password: [null, [Validators.required]],
    });
  }

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   this.timePickerFc.setValue(new Date())
    // })
  }

  public get name() {
    return this.form.get('name');
  }

  onSubmit() {
    this.submitted = true;    
  }

  onReset() {
    this.submitted = false;
    this.form.reset();
  }

  updateValidators() {
    const field = this.form.get('name');

    if (this.validatorsUpdated) {
      field.setValidators([]);
    } else {
      field.setValidators([Validators.required]);
    }

    this.validatorsUpdated = !this.validatorsUpdated;

    field.updateValueAndValidity();
  }

  onBlur() {
    console.log("TIME PICKER BLUR!")
  }
}
